import React, { useEffect, useState } from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { Flex, Image } from "antd";
import { useDispatch } from "react-redux";
import { openNotification } from "src/components/helpers/notification";
import { getClientsList, getAgreement } from "src/store/Slices/ClientsSlice";

const WatchAgreeModal = ({
  visible,
  setVisible,
  clientInfo,
  addEditPayload,
}) => {
  const dispatch = useDispatch();
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);

  const fetchAgreement = async () => {
    try {
      const response = await dispatch(
        getAgreement({ value: { userId: clientInfo?.id } })
      );
      const blob = response?.payload;

      if (!(blob instanceof Blob)) {
        openNotification("Получен неверный формат файла", "error");
        return;
      }

      setFileType(blob.type);

      const url = URL.createObjectURL(blob);
      setFileUrl(url);

      dispatch(getClientsList(addEditPayload));
    } catch (err) {
      openNotification("Ошибка при получении соглашения", "error");
    }
  };

  useEffect(() => {
    if (visible) {
      fetchAgreement();
    } else {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
        setFileUrl(null);
        setFileType(null);
      }
    }
  }, [visible]);

  const renderContent = () => {
    if (!fileUrl) return null;

    if (fileType.startsWith("image/")) {
      // Render image preview
      return (
        <Image
          style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
          alt="Отсутствует изображение"
          src={fileUrl}
          fallback="https://placehold.co/400x400?text=No+Photo"
        />
      );
    }

    if (fileType === "application/pdf") {
      // Render PDF preview inside iframe
      return (
        <iframe
          title="PDF Preview"
          src={fileUrl}
          style={{ width: "100%", height: "80vh", border: "none" }}
        />
      );
    }

    // For other file types, offer a download link/button
    return (
      <div>
        <p>Файл не может быть предварительно просмотрен.</p>
        <a href={fileUrl} download={`agreement${getFileExtension(fileType)}`}>
          Скачать файл
        </a>
      </div>
    );
  };

  // Helper to get file extension from MIME type
  const getFileExtension = (mime) => {
    switch (mime) {
      case "application/pdf":
        return ".pdf";
      case "application/msword":
        return ".doc";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return ".docx";
      case "application/vnd.ms-excel":
        return ".xls";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return ".xlsx";
      // add more if needed
      default:
        return "";
    }
  };

  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={() => setVisible(false)}
      aria-labelledby="VerticallyCenteredExample"
      size="lg"
      scrollable
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">Соглашение</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ textAlign: "center" }}>
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          {renderContent()}
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary text-light" onClick={() => setVisible(false)}>
          Закрыть
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default WatchAgreeModal;
